export function alphabetize<T>(items: T[], key: string): T[] {
  return sortAscending(items, item => {
    return `${(item as any)[key]}`.toUpperCase()
  })
}

export function sortAscending<T, S>(items: T[], getValueForCompareFn: (item: T) => S): T[] {
  return innerSort(items, getValueForCompareFn, true)
}

export function sortDescending<T, S>(items: T[], getValueForCompareFn: (item: T) => S): T[] {
  return innerSort(items, getValueForCompareFn, false)
}

export function sortNumbersAscending(items: number[]): number[] {
  return innerSort(items, item => item, true)
}

export function sortNumbersDescending(items: number[]): number[] {
  return innerSort(items, item => item, false)
}

/**
 * Returns a sorted copy using a comparator. Use this when a single sort key cannot express the
 * order, such as a null-last metric with a separate tie-break.
 */
export function sortBy<T>(items: T[], compare: (left: T, right: T) => number): T[] {
  return items.slice().sort(compare)
}

function innerSort<T, S>(
  items: T[],
  getValueForCompareFn: (item: T) => S,
  ascending: boolean
): T[] {
  const inverse = ascending ? 1 : -1
  return items
    .slice()
    .sort((a: T, b: T) =>
      getValueForCompareFn(a) > getValueForCompareFn(b) ? 1 * inverse : -1 * inverse
    )
}
